import React from 'react';
import Table from '../../../../common/Table';
import Alert from '../../../../common/informative/Alert';
import {
  maintenanceFailModeCategoryInformationDefaultProps,
  maintenanceFailModeCategoryInformationPropTypes,
} from '../proptypes/MaintenanceFailModePropTypes';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import { MAINTENANCE_FAIL_MODE_CATEGORY_COLUMNS } from '../../../../../config/columns';

const MaintenanceFailModeCategoryBasicInformationResource = ({
  maintenanceFailModeCategoryList,
}) => {
  if (maintenanceFailModeCategoryList.length === 0)
    return (
      <Alert
        type="warning"
        message="Modo de falla no tiene categorías asignadas."
      />
    );

  const data = maintenanceFailModeCategoryList.map((category) => ({
    name: category.name || '-',
  }));

  return (
    <Table
      columns={MAINTENANCE_FAIL_MODE_CATEGORY_COLUMNS}
      data={data}
      filterable
      manual={false}
      defaultFilterMethod={filterMethodCaseInsensitive}
      defaultPageSize={
        maintenanceFailModeCategoryList.length > 10
          ? DEFAULT_PAGE_SIZE
          : maintenanceFailModeCategoryList.length
      }
      showPagination={maintenanceFailModeCategoryList.length > 10}
    />
  );
};

MaintenanceFailModeCategoryBasicInformationResource.propTypes =
  maintenanceFailModeCategoryInformationPropTypes;

MaintenanceFailModeCategoryBasicInformationResource.defaultProps =
  maintenanceFailModeCategoryInformationDefaultProps;

export default MaintenanceFailModeCategoryBasicInformationResource;
